import actions from '@/core/store/tipo-documento/actions'

export default {
	actions,
}
